import isNil from 'lodash/isNil'
import omitBy from 'lodash/omitBy'
import queryString from 'query-string'
import { ISavedLanesFilters } from './getSavedLaneBookingFilters'

export const getSavedLaneBookingLink = (savedLaneFilters: ISavedLanesFilters): string => {
  const { pickupIsoDaysOfWeek = [] } = savedLaneFilters || {}
  const filters = {
    ...savedLaneFilters,
    pickupIsoDaysOfWeek: pickupIsoDaysOfWeek ? pickupIsoDaysOfWeek.join('_') : null,
  }
  const query = queryString.stringify({
    ...omitBy(filters, isNil),
  })
  return `/book/?${query}`
}
